const commands = [
  {
    path: 'ipc',
    name: 'command_ipc',
    icon: 'cil-list-high-priority',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/commands/Ipc.vue'),
    },
    meta: {
      requiredRole: ['admin'],
      moduleSlug: 'command-ipc'
    }
  },
  {
    path: 'users',
    name: 'command_users',
    icon: 'cil-list-high-priority',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/commands/UserImport.vue'),
    },
    meta: {
      requiredRole: ['admin'],
      moduleSlug: 'command-users'
    }
  },
  {
    path: 'import-adex',
    name: 'import_adex',
    icon: 'cil-list-high-priority',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/adex/Import.vue'),
    },
    meta: {
      requiredRole: ['admin'],
      moduleSlug: 'adex'
    }
  },
  {
    path: 'booster-importer',
    name: 'booster_importer',
    icon: 'cil-list-high-priority',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/commands/BoosterImporter.vue'),
    },
    meta: {
      requiredRole: ['admin'],
      moduleSlug: 'booster-ccs'
    }
  }
]

export default commands
